'use strict';

(function() {

	angular.module('onboarding',
		[
			// Shared modules
			'onboarding.services',
			'onboarding.constants',
			'onboarding.common',
			'onboarding.common.security',
			'onboarding.common.settings',
			'onboarding.broker',
			'onboarding.broker.carriers',
			'onboarding.broker.contracts',
			'onboarding.carrier',
			'onboarding.internaladmin',
			'dat.shared-components.common',

			// 3rd-party modules (needed by this module)
			'ui',
			'ui.router',
			'ui.select2',
			'ngSanitize',
			'ngFileUpload'
		])
		.config([
			'$stateProvider', '$urlRouterProvider', '$locationProvider',
			function($stateProvider, $urlRouterProvider, $locationProvider) {
				// Route definitions are in the module of the respective area. We only provide the default route here.

				$urlRouterProvider.otherwise('/');

				$locationProvider.html5Mode(true);

				$stateProvider
					.state('base',
						{
							url: '/',
							template: ''
						})
					.state('dot',
						{
							url: '/dot',
							template: '<cob-welcome-page></cob-welcome-page>'
						})
					.state('intrastate',
						{
							url: '/intrastate',
							template: '<cob-welcome-page></cob-welcome-page>'
						})
					.state('canadian',
						{
							url: '/canadian',
							template: '<cob-welcome-page></cob-welcome-page>'
						})
					.state('selectcarrier',
						{
							url: '/selectcarrier',
							template: '<cob-welcome-page></cob-welcome-page>'
						})
					.state('confirmCompany',
						{
							url: '/confirmCompany',
							template: '<cob-confirm-company></cob-confirm-company>'
						})
					.state('registration',
						{
							url: '/registration',
							template: '<cob-carrier-registration></cob-carrier-registration>'
						})
					.state('carriers',
						{
							url: '/carriers?brokerId',
							template: '<cob-carrier-list></cob-carrier-list>'
						})
					.state('carrierProfile',
						{
							url: '/profile',
							abstract: true,
							templateUrl: '/app/carrier/profile/carrierProfile.html'
						})
					.state('carrierProfile.company',
						{
							url: '/company?carrierId&brokerId',
							template: '<cob-carrier-profile-company></cob-carrier-profile-company>',
							parent: 'carrierProfile'
						})
					.state('carrierProfile.company.showModal',
						{
							url: '/modal',
							template: '<cob-carrier-welcome-modal></cob-carrier-welcome-modal>',
							parent: 'carrierProfile.company'
						})
					.state('carrierProfile.contacts',
						{
							url: '/contacts?carrierId&brokerId',
							template: '<cob-carrier-profile-contacts></cob-carrier-profile-contacts>',
							parent: 'carrierProfile'
						})
					.state('carrierProfile.fleetServices',
						{
							url: '/fleetservices?carrierId&brokerId',
							template: '<cob-carrier-profile-fleet-services></cob-carrier-profile-fleet-services>',
							parent: 'carrierProfile'
						})
					.state('carrierProfile.laneCoverage',
						{
							url: '/laneCoverage?carrierId&brokerId',
							template: '<cob-carrier-profile-lane-coverage></cob-carrier-profile-lange-coverage>',
							parent: 'carrierProfile'
						})
					.state('carrierProfile.taxes',
						{
							url: '/taxes?carrierId&brokerId',
							template: '<cob-carrier-profile-taxes></cob-carrier-profile-taxes>',
							parent: 'carrierProfile'
						})
					.state('carrierProfile.insurance',
						{
							url: '/insurance?carrierId&brokerId',
							template: '<cob-carrier-profile-insurance></cob-carrier-profile-insurance>',
							parent: 'carrierProfile'
						})
					.state('carrierProfile.documents',
						{
							url: '/documents?carrierId&brokerId',
							template: '<cob-carrier-profile-documents></cob-carrier-profile-documents>',
							parent: 'carrierProfile'
						})
					.state('carrierProfile.contracts',
						{
							url: '/contracts?carrierId&brokerId',
							template: '<cob-carrier-profile-contracts></cob-carrier-profile-contracts>',
							parent: 'carrierProfile'
						})
					.state('contracts',
						{
							url: '/activecontracts?brokerId',
							template: '<cob-contract-list></cob-contract-list>'
						})
					.state('contractfamily',
						{
							url: '/contractfamily?brokerId&contractid',
							template: '<cob-contract-versions-list></cob-contract-versions-list>'
						})
					.state('contractsignatures',
						{
							url: '/contractsignatures?brokerId&contractid',
							template: '<cob-contract-signatures-list></cob-contract-signatures-list>'
						})
					.state('brokersAdmin',
						{
							url: '/brokersAdmin',
							template: '<cob-admin-broker-list></cob-admin-broker-list>'
						})
					.state('carriersAdmin',
						{
							url: '/carriersAdmin',
							template: '<cob-admin-carrier-list></cob-admin-carrier-list>'
						})
					.state('reportsAdmin',
						{
							url: '/reportsAdmin',
							template: '<cob-admin-broker-usage-report></cob-admin-broker-usage-report>'
						})
					.state('contractsAdmin',
						{
							url: '/contractsAdmin',
							template: '<cob-admin-contract-list></cob-admin-contract-list>'
						})
					.state('unauthorized',
						{
							url: '/unauthorized',
							templateUrl: '/app/common/security/cobUnauthorized.html'
						});
			}
		])
		.config([
			'$httpProvider', function($httpProvider) {
				'use strict';
				$httpProvider.interceptors.push('onboardHttpInterceptor');
			}
		])
		.config([
			'$logProvider', function($logProvider) {
				$logProvider.debugEnabled(false);
			}
		])
		.config([
			'$provide', function($provide) {
				return $provide.decorator('$log',
					[
						'$delegate', function($delegate) {
							var debug = $delegate.debug;

							// Comment out the line below to see $log.debug statements
							//$delegate.debug = function() {}; // no-op
							return $delegate;
						}
					]);
			}
		])
		.config([
			'$provide', function($provide) {
				return $provide.decorator('$location',
					[
						'$delegate', '$injector', function($location, $injector) {
							var skipping = false;
							var $rootScope = $injector.get('$rootScope');

							$rootScope.$on('$locationChangeSuccess',
								function(event) {
									if (skipping) {
										event.preventDefault();
										skipping = false;
									}
								});

							$location.skipReload = function() {
								skipping = true;

								return this;
							};

							return $location;
						}
					]);
			}
		])
		.run([
			'$rootScope', 'sessionService', 'authenticationService', '$state', '$stateParams',
			'subjectObserverMessagesService',
			'observerService',
			'$timeout', '$window', function assignServicesToRootScope($rootScope,
				sessionService,
				authenticationService,
				$state,
				$stateParams,
				subjectObserverMessagesService,
				observerService,
				$timeout, $window) {
				$rootScope.$state = $state;
				$rootScope.$stateParams = $stateParams;
				$rootScope.sessionService = sessionService;
				$rootScope.authenticationService = authenticationService;
				$rootScope.whiteList = ['intrastate', 'canadian', 'dot', 'selectcarrier', 'confirmCompany', 'registration'];
				$rootScope.sessionService.restoreState();

				var domain = $('base').attr('href').split('/')[1];
				var lastVisitedPage = $rootScope.sessionService.getLastVisitedPage();

				if (domain) {
					$rootScope.sessionService.setDomain(domain, $rootScope);
				}

				var subjectMessages = subjectObserverMessagesService.getSubjectMessages();
				var isAuthenticated,
					currentStateName;
				authenticationService.getUserInfo($rootScope)
					.then(function(response) {
						isAuthenticated = response.data.isAuthenticated;
						currentStateName = $state.$current.name;

						if (isAuthenticated) {
							var sessionData = {
								userName: sessionService.getUserName(),
								capabilityIds: sessionService.getCapabilities(),
								page: $rootScope.destination
							};
							var roleChanched = lastVisitedPage && lastVisitedPage.capabilities 
                                && sessionData.capabilityIds 
                                && (lastVisitedPage.capabilities[0] !== sessionData.capabilityIds[0]);
                            
							if (roleChanched) {
								lastVisitedPage = null;
							}

							if (currentStateName === 'base' || $rootScope.whiteList.indexOf(currentStateName) !== -1) {
								if (sessionService.isAuthorizedInternalAdmin()) {
									sessionData.page = 'carriersAdmin';
									observerService
										.sendMessageToSubject($rootScope,
											subjectMessages.COB_SUBJECT_LOGIN_FINISHED_SUCCESS,
											sessionData);
									stateGo('carriersAdmin');
            
									return;
								} else if (sessionService.isAuthorizedBrokerRead()) {
									sessionData.page = 'carriers';
									observerService
										.sendMessageToSubject($rootScope,
											subjectMessages.COB_SUBJECT_LOGIN_FINISHED_SUCCESS,
											sessionData);
									stateGo('carriers');
            
									return;
								} else if (sessionService.isAuthorizedCarrierRead()) {
									sessionData.page = 'carrierProfile.company';
									observerService
										.sendMessageToSubject($rootScope,
											subjectMessages.COB_SUBJECT_LOGIN_FINISHED_SUCCESS,
											sessionData);
									stateGo('carrierProfile.company');
            
									return;
								}
                              
							}

							$timeout(function() {
								observerService
									.sendMessageToSubject($rootScope,
										subjectMessages.COB_SUBJECT_LOGIN_FINISHED_SUCCESS,
										sessionData);
							}, 200);
    
							return;
						} else {

							if ($rootScope.whiteList.indexOf(currentStateName) === -1 && currentStateName !== '') {
								sessionService.redirectToLogin();

								return;
							}
						}

						function stateGo(stateName) {
							if (lastVisitedPage) {
								$state.go(lastVisitedPage.name, lastVisitedPage.params);
							} else {
								$state.go(stateName);
							}
						}
					});
			}
		])
		.run([
			'$rootScope', '$location', '$state', 'subjectObserverMessagesService', 'observerService', '$window',
			function checkAccessOnStateChange($rootScope,
				$location,
				$state,
				subjectObserverMessagesService,
				observerService,
				$window) {

				$rootScope.$on('$stateChangeStart',
					function(event, toState, toParams, fromState) {
						var shouldSaveCurrentState, isBrokerOnCarrierView;
						$rootScope.destination = toState.name;
						var isAuthenticated = $rootScope.authenticationService.isAuthenticated();

						if (toState.name === 'urlnotfound') {
							return;
						}
						if (isAuthenticated) {
							var subjectMessages = subjectObserverMessagesService.getSubjectMessages();
							observerService.sendMessageToSubject($rootScope, subjectMessages.COB_SUBJECT_VIEW_CHANGE, toState.name);
							isBrokerOnCarrierView = Boolean($rootScope.sessionService.isAuthorizedBrokerRead() && toParams.carrierId);
							shouldSaveCurrentState = toState.name !== 'base' && $rootScope.whiteList.indexOf(toState.name) === -1 && !isBrokerOnCarrierView;

							if (shouldSaveCurrentState) {
								$rootScope.sessionService.setLastVisitedPage({name: toState.name, params: toParams});
							}
                            
							if (isBrokerOnCarrierView) {
								$rootScope.sessionService.removeLastVisitedPage();
							}

							switch (toState.name) {
							case 'brokersAdmin':
							case 'carriersAdmin':
							case 'contractsAdmin':
							case 'reportsAdmin':
								if (!$rootScope.sessionService.isAuthorizedInternalAdmin()) {
									event.preventDefault();
									$state.transitionTo('base');
								}
								break;
							case 'carriers':
							case 'contracts':
								if ($rootScope.sessionService.isAuthorizedInternalAdmin() && !toParams.brokerId) {
									event.preventDefault();
									$state.transitionTo('brokersAdmin');
								}
								if (!$rootScope.sessionService.isAuthorizedBrokerRead() &&
                                        !$rootScope.sessionService.isAuthorizedInternalAdmin()) {
        
									event.preventDefault();
									$state.transitionTo('base');
								}
								break;
							case 'carrierProfile.company':
							case 'carrierProfile.company.showModal':
							case 'carrierProfile.contacts':
							case 'carrierProfile.fleetServices':
							case 'carrierProfile.laneCoverage':
							case 'carrierProfile.taxes':
							case 'carrierProfile.insurance':
							case 'carrierProfile.documents':
							case 'carrierProfile.contracts':
								if (!$rootScope.sessionService.isAuthorizedCarrierRead() && !toParams.carrierId) {
									event.preventDefault();
									$state.transitionTo('base');
								}
								break;
							default:
								if ($rootScope.sessionService.isAuthorizedInternalAdmin() && !toParams.brokerId) {
									event.preventDefault();
									$state.transitionTo('brokersAdmin');
								}
        
								return;
							}
                            
							return;
						} else if (toState.name === 'base') {
							var domain = $('base').attr('href').split('/')[1];
							if (domain) {
								event.preventDefault();
								$state.transitionTo('dot');
							}
						} else if (toState.name === 'confirmCompany') {
							$rootScope.previousRegistrationState = fromState.name;
						} else if (toState.name === 'dot' && (fromState.name === 'registration' || 'confirmCompany')) {
							if ($rootScope
								.previousRegistrationState &&
                                $rootScope.previousRegistrationState !== 'dot') {
								event.preventDefault();
								$state.transitionTo($rootScope.previousRegistrationState);
								$rootScope.previousRegistrationState = undefined;
							}
						}

						return;
					});
			}
		]);

	angular.element(document).ready(function () {
		angular.bootstrap(document, ['onboarding']);
	});

})();
